var base = require('./base');
var focusHelper = require('../components/focus');
var detail = require('../product/detail');
var tileTracking = require('./tile');

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog" data-backdrop="static" data-keyboard="false">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}


/**
* Hides or shows the SOR schedules based on the given value
* @param {string} value - the given value
*/
function hideOrShowSchedules(value) {
    if (value === 'true') {
        if (window.innerWidth < 568) {
            $('.smart-order-refill-period').attr('style', 'margin: 15px 20px');
        }
        $('.smart-order-refill-period').attr('style', 'display:inline-block');
        $('#everyDelivery').trigger('change');
        $('.weeks-block').attr('style', 'display:block');
    } else {
        $('.or-cancel-edit-text').attr('style', 'margin-top:10px');
        $('.smart-order-refill-period').attr('style', 'display:none');
        $('.weeks-block').attr('style', 'display:none');
        if ($('input[name=variantSelected]').val()) {
            $('#add-to-cart').removeAttr('disabled');
        }
    }
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');
            $('input[name=hasSmartOrderRefill]').change(function () {
                hideOrShowSchedules($(this).is(':checked') ? 'true' : 'false');
            }).change();
            $('button.btn-week.js-sor-interval-pdp').removeClass('active');

            handleDualMode();

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Handles logic for dual mode customers that were redirected to S&S
 */
function handleDualMode() {
    // Get the default interval option value from the checkbox data attribute
    var defaultIntervalOption = $('#OsfSorRefillProductYes').data('default-interval-option');

    if (window.sf_isWizardSubSession && window.sf_isWizardSubSession === 'true') {
        $('.repeat-order-block .row').hide();
        $('.repeat-order-block + .weeks-block').hide();
        $('[name="hasSmartOrderRefill"]').prop('checked', true);

        defaultIntervalOption = $('#OsfSorRefillProductYes').data('dualmode-interval');
        $('[name="SorDeliveryWeekInterval"]').val(defaultIntervalOption).trigger('change');
    }

    $('button.btn-week.js-sor-interval-pdp[data-value=\'' + defaultIntervalOption + '\']').addClass('active');
}

module.exports = {
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
            tileTracking.persistTrackingContext(tileTracking.getTrackingContext($(this).closest('.product-tile')));
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    changeSORPriceQuickview: detail.applySORDiscountPDP,
    availability: base.availability,
    addToCart: base.addToCart,
    onSelectTab: detail.onSelectTab,
    updatePriceOnQuantity: base.updatePriceOnQuantity,
    customAttributeSelection: base.customAttributeSelection,
    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available')
            );
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);


            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    },
    pdpSwiper: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            var Swiper = require('swiper');
            new Swiper('.pdp-swiper-large', {
                zoom: false,
                slidesPerView: 5,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
            });
            new Swiper('.pdp-swiper-small', {
                zoom: false,
                pagination: '.swiper-pagination',
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                centeredSlides: true,
                paginationClickable: true,
                keyboardControl: false,
                mousewheelControl: false,
                mousewheelForceToAxis: true,
                grabCursor: true
            });
            var dataSlideThreshold = $('.recommendations-wrapper').attr('data-slidethreshold');
            var slideThreshold = dataSlideThreshold ? parseInt(dataSlideThreshold, 10) : 4;
            new Swiper('.swiper-recommendations', {
                zoom: false,
                pagination: '.swiper-pagination-recommendations',
                slidesPerView: slideThreshold,
                centeredSlides: false,
                paginationClickable: true,
                keyboardControl: false,
                grabCursor: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                loop: true
            });
            new Swiper('.swiper-recommendations-sm', {
                zoom: false,
                pagination: '.swiper-pagination-recommendations-sm',
                slidesPerView: 1.2,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                centeredSlides: false,
                paginationClickable: true,
                keyboardControl: false,
                mousewheelControl: false,
                mousewheelForceToAxis: true,
                grabCursor: true,
                loop: true,
                spaceBetween: 10
            });
        });
    },
    quantityButtonsDecrement: function () {
        $('body').on('click', '.pdp-quantity button.less', function () {
            var $input = $(this).siblings('.number-input-input-wrapper').find('input.quantity');
            var val = parseInt($input.val(), 10);
            var $addToCartButton = $('.add-to-cart');
            if (val > 1) {
                $input.val(val - 1);
                $input.trigger('change');
                $addToCartButton.data('item-quantity', $input.val());
            }
        });
    },
    quantityButtonsIncrement: function () {
        $('body').on('click', '.pdp-quantity button.plus', function () {
            var $input = $(this).siblings('.number-input-input-wrapper').find('input.quantity');
            var val = parseInt($input.val(), 10);
            var $addToCartButton = $('.add-to-cart');
            $input.val(val + 1);
            $input.trigger('change');
            $addToCartButton.data('item-quantity', $input.val());
        });
    }
};
